module.exports = __webpack_public_path__ + "img/privilege_1_img1.8d5a7dda.png";